// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Organization hierarchy level.
 */
export enum OrgType {
  MASTER = 0,
  ORG = 1,
  SUBORG = 2,
}
